import { darken, type Theme } from '@mui/material/styles';

const LIGHT_MODE_DARKEN = 0.45;

export function readableTone(color: string, theme: Theme): string {
    return theme.palette.mode === 'light'
        ? darken(color, LIGHT_MODE_DARKEN)
        : color;
}
